export default __webpack_public_path__ + "static/media/profile.5732493d.png";